module.exports = __webpack_public_path__ + "static/img/r-5-1-icon.7b3bbd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/r-5-1-icon.png
// module id = hbcj
// module chunks = 0